import React from 'react';
import { PromotionStateLive } from '../PromotionStateLive';
import { PromotionStateCountdown } from '../PromotionStateCountdown';
import { PromotionStateExpired } from '../PromotionStateExpired';
import { PromotionsService } from '../../../../../../shared/src/services/promotions.service';
import { ltPromotionStatusesEnum } from '../../../../../../shared/src/enums/promotions.enum';

export const PromotionStateIndicator = ({
    schedule,
    clockTitle,
}) => {
    const {
        liveModeStartDate,
        endDate,
    } = schedule;
    const promotionStatus = PromotionsService.getPromotionsStatus(schedule);
    const statusComponentsMap = {
        [ltPromotionStatusesEnum.EXPIRED]: <PromotionStateExpired />,
        [ltPromotionStatusesEnum.LIVE]: <PromotionStateLive />,
        [ltPromotionStatusesEnum.COUNTDOWN_TILL_LIVE]: <PromotionStateCountdown
            className="asg-promotion-fold-thumbnail__state-countdown"
            tillDateObj={new Date(liveModeStartDate)}
            text={clockTitle}
        />,
        [ltPromotionStatusesEnum.COUNTDOWN_TILL_END]: <PromotionStateCountdown
            className="asg-promotion-fold-thumbnail__state-countdown"
            tillDateObj={new Date(endDate)}
            text={clockTitle}
        />
    };

    const stateComponent = statusComponentsMap[promotionStatus] ?? null;

    if (!stateComponent) {
        return null;
    }

    return (
        <div className="asg-promotion-fold-thumbnail__state-indicator">
            {stateComponent}
        </div>
    );
};
